// src/App.js
import React from "react";
import "./App.css";
import AppRoutes from "./router/routes";

function App() {
  return <AppRoutes />;
}

export default App;
